import { Skeleton } from "~/components/ui/skeleton";

export function DramaCardDarkSkeleton() {
  return (
    <div className="flex flex-col gap-[4px]">
      <Skeleton className="aspect-[2/3] w-full rounded-[12px] bg-neutral-800" />
      <div>
        <Skeleton className="h-[20px] w-full bg-neutral-800" />
        <Skeleton className="h-[14px] w-1/3 bg-neutral-800" />
      </div>
    </div>
  );
}
